export const environment = {
  production: true,
  url: 'https://damsy.siemens.cloud'
};
